"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _order = require("@/api/order");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    visible: Boolean
  },
  data: function data() {
    var check = function check(rule, value, callback) {
      if (!value.length) {
        return callback(new Error('请选择身份'));
      }
      callback();
    };
    return {
      visible2: false,
      form: {
        roleTypes: [],
        reason: null
      },
      info1: {},
      //财务
      info2: {},
      //买家
      rules: {
        roleTypes: [{
          validator: check,
          trigger: 'blur'
        }],
        reason: [{
          required: true,
          message: '请输入拒绝原因',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    closeInner: function closeInner() {
      console.log('关闭');
      this.form = {
        roleTypes: [],
        reason: null
      };
    },
    pz: function pz(str, c) {
      return "".concat(str, "(").concat(c, ")");
    },
    auditTypeText: function auditTypeText(str) {
      if (str == 1) return '定金';
      if (str == 2) return '尾款';
      return '总额';
    },
    success: function () {
      var _success = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var data, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              data = {
                businessSerialNumber: this.info1.businessSerialNumber,
                //业务流水号
                reason: undefined,
                //拒绝理由
                amount: this.info1.amountOfPayment,
                //审核金额
                orderNo: this.info1.orderNo,
                //订单号
                auditType: this.info1.auditType,
                //审核业务类型（1.定金，2.尾款，3.全款）
                roleTypes: [1, 2],
                //通过/拒绝角色 1：买家。2.财务
                status: 3 //3：通过，4：拒绝
              };
              this.loading = true;
              _context.n = 1;
              return (0, _order.auditOrderReviewRecord)(data);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.data.errno == 0) {
                this.$message.success('审核通过');
                this.$emit('refresh', true);
                this.close();
                this.visible2 = false;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function success() {
        return _success.apply(this, arguments);
      }
      return success;
    }(),
    auditOrderReviewRecord: function auditOrderReviewRecord() {},
    opened: function () {
      var _opened = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var orderNo, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log(23, this.$attrs, 'this.$atters.info');
              _context2.p = 1;
              this.loading = true;
              orderNo = this.$attrs.info.orderSn;
              _context2.n = 2;
              return (0, _order.getOrderReviewRecord)({
                orderNo: orderNo
              });
            case 2:
              res = _context2.v;
              this.loading = false;
              if (res.data.errno == 0) {
                this.info1 = res.data.data.reviewRecord.filter(function (item) {
                  return item.roleType == 2;
                })[0];
                this.info2 = res.data.data.reviewRecord.filter(function (item) {
                  return item.roleType == 1;
                })[0];
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log(_t2, 'error');
              this.loading = false;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function opened() {
        return _opened.apply(this, arguments);
      }
      return opened;
    }(),
    close: function close() {
      this.$emit("update:visible", false);
    },
    cancel: function cancel() {
      this.visible2 = true;
    },
    dowloadbtn: function dowloadbtn() {
      console.log('下载');
    },
    confirm: function confirm(formName) {
      var _this = this;
      this.$refs[formName].validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(valid) {
          var data, res, _t3;
          return (0, _regenerator2.default)().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (!valid) {
                  _context3.n = 5;
                  break;
                }
                _context3.p = 1;
                data = {
                  businessSerialNumber: _this.info1.businessSerialNumber,
                  //业务流水号
                  reason: _this.form.reason,
                  //拒绝理由
                  amount: _this.info2.amountOfPayment,
                  //审核金额
                  orderNo: _this.info1.orderNo,
                  //订单号
                  auditType: _this.info1.auditType,
                  //审核业务类型（1.定金，2.尾款，3.全款）
                  roleTypes: _this.form.roleTypes,
                  //通过/拒绝角色 1：买家。2.财务
                  status: 4 //3：通过，4：拒绝
                };
                _this.loading = true;
                _context3.n = 2;
                return (0, _order.auditOrderReviewRecord)(data);
              case 2:
                res = _context3.v;
                console.log(res, 'res');
                _this.loading = false;
                if (res.data.errno == 0) {
                  _this.$message.success('审核完成');
                  _this.$emit('refresh', true);
                  _this.close();
                  _this.visible2 = false;
                }
                _context3.n = 4;
                break;
              case 3:
                _context3.p = 3;
                _t3 = _context3.v;
                console.log(_t3, 'orororor');
              case 4:
                _context3.n = 6;
                break;
              case 5:
                console.log('error submit!!');
                return _context3.a(2, false);
              case 6:
                return _context3.a(2);
            }
          }, _callee3, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  components: {}
};